import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {UserListComponent} from './user-list/user-list.component';
import {UserAddComponent} from './user-add/user-add.component';
import {UserEditComponent} from './user-edit/user-edit.component';
import {IsAdminGuard} from '../security/is-admin.guard';
import {UserResolver} from './user-resolver';
import {UserBulkImportComponent} from './user-bulk-import/user-bulk-import.component';


const routes: Routes = [
  {
    path: 'users',
    children: [
      {path: '', component: UserListComponent},
      {path: 'import', component: UserBulkImportComponent},
      {path: 'add', component: UserAddComponent},
      {
        path: 'edit/:userId',
        component: UserEditComponent,
        resolve: {
          user: UserResolver
        }},
    ],
    canActivate: [IsAdminGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
